export default __webpack_public_path__ + "static/media/optometryCompleted.85b9a150.svg";